import {ReduxAction} from '../redux';

export function getFetchKey({type, fetchKey}: ReduxAction) {
  return fetchKey === undefined ? type : String(fetchKey);
}
